// import axios2 from 'axios'
import axios from '@/functions/axios-instance'
import i18n from './../locales/i18n'
import Cookies from 'js-cookie'

export default {
    name: "function",
    convDateTimeFormat (d: string | Date ="", format: string = "") {
        // input format: 2021-11-18T23:11:41.000Z (from backend) OR Fri Nov 19 2021 15:11:41 GMT+0800 (Malaysia Time)
        const date = new Date(d)

        if (format === "date") {
            // Sample: 2026-12-25
            const month = (date.getMonth() * 1 + 1) + ''
            const day = date.getDate() + ''

            return date.getFullYear() + '-' + (month.length === 2 ? month : '0' + month) + '-' + (day.length === 2 ? day : '0' + day)

        } else if (format === "text") {
            // Sample: 25Dec2026 10:15
            // const month = (date.getMonth() * 1 + 1) + ''
            const day = date.getDate() + ''
            const hour = date.getHours() + ''
            const minute = date.getMinutes() + ''
            const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

            return (day.length === 2 ? day : '0' + day) + month[date.getMonth()] + date.getFullYear()  + ' ' + (hour.length === 2 ? hour : '0' + hour) + ':' + (minute.length === 2 ? minute : '0' + minute)
        
        } else if (format === "datetext") {
            // Sample: 25Dec2026
            // const month = (date.getMonth() * 1 + 1) + ''
            const day = date.getDate() + ''
            const hour = date.getHours() + ''
            const minute = date.getMinutes() + ''
            const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

            return (day.length === 2 ? day : '0' + day) + month[date.getMonth()] + date.getFullYear()

        } else if (format === "daymonthtext") {
            // Sample: 25 Dec
            const day = date.getDate() + ''
            const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

            return (day.length === 2 ? day : '0' + day) + ' ' + month[date.getMonth()]

        } else if (format === "monthyeartext") {
            // Sample: Dec 2026
            const day = date.getDate() + ''
            const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

            return month[date.getMonth()] + ' ' + date.getFullYear()

        } else if (format === "datetime") {
            // Sample: 2026-12-25 10:12
            // convert to YYYY-MM-DD HH:II
            const month = (date.getMonth() * 1 + 1) + ''
            const day = date.getDate() + ''
            const hour = date.getHours() + ''
            const minute = date.getMinutes() + ''

            return date.getFullYear() + '-' + (month.length === 2 ? month : '0' + month) + '-' + (day.length === 2 ? day : '0' + day) + ' ' + (hour.length === 2 ? hour : '0' + hour) + ':' + (minute.length === 2 ? minute : '0' + minute)

        } else if (format === "fulldatetime") {
            // Sample: 2026-12-25 10:12:30
            // convert to YYYY-MM-DD HH:II:SS
            const month = (date.getMonth() * 1 + 1) + ''
            const day = date.getDate() + ''
            const hour = date.getHours() + ''
            const minute = date.getMinutes() + ''
            const second = date.getSeconds() + ''

            return date.getFullYear() + '-' + (month.length === 2 ? month : '0' + month) + '-' + (day.length === 2 ? day : '0' + day) + ' ' + (hour.length === 2 ? hour : '0' + hour) + ':' + (minute.length === 2 ? minute : '0' + minute) + ':' + (second.length === 2 ? second : '0' + second)
        
        } else if (format === "datetimegmt") {
            // Sample: 15Nov2024 06:00PM GMT+8
            const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
            const day = date.getDate() + ''
            // const hour = date.getHours() + ''
            const minute = date.getMinutes() + ''
            // const second = date.getSeconds() + ''

            const ampm = date.getHours() >= 12 ? 'PM' : 'AM'
            let hour2 = (date.getHours() % 12) + '' // Convert 24-hour format to 12-hour format

            const offsetMinutes = date.getTimezoneOffset()
            const offsetHours = -offsetMinutes / 60 // The offset is in minutes, and we want it in hours.

            // return (day.length === 2 ? day : '0' + day) + month[date.getMonth()] + date.getFullYear() + ' ' + (hour.length === 2 ? hour : '0' + hour) + ':' + (minute.length === 2 ? minute : '0' + minute) + ':' + (second.length === 2 ? second : '0' + second) + ' GMT' + (offsetHours >= 0 ? '+' : '') + offsetHours
            return (day.length === 2 ? day : '0' + day) + month[date.getMonth()] + date.getFullYear() + ' ' + (hour2.length === 2 ? hour2 : '0' + hour2) + ':' + (minute.length === 2 ? minute : '0' + minute) + ampm + ' GMT' + (offsetHours >= 0 ? '+' : '') + offsetHours
        
        } else if (format === "datetimegmt2") {
            // Sample: 15Nov2024 06:00PM GMT+8
            const month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
            const day = date.getDate() + ''
            const hour = date.getHours() + ''
            const minute = date.getMinutes() + ''
            // const second = date.getSeconds() + ''

            const ampm = date.getHours() >= 12 ? 'PM' : 'AM'
            let hour2 = (date.getHours() % 12) + '' // Convert 24-hour format to 12-hour format

            const offsetMinutes = date.getTimezoneOffset()
            const offsetHours = -offsetMinutes / 60 // The offset is in minutes, and we want it in hours.

            return (day.length === 2 ? day : '0' + day) + month[date.getMonth()] + date.getFullYear() + ' ' + date.getHours() + ':' + (minute.length === 2 ? minute : '0' + minute) + ' ' + (offsetHours >= 0 ? '+' : '') + (offsetHours.toString.length === 2 ? offsetHours : '0' + offsetHours) + ':00'
        
        } else {
            // Sample: Fri Nov 19 2021 15:11:41 GMT+0800 (Malaysia Time)
            return date.toDateString() + ' ' + date.toTimeString()
        }
    },
    convDob (d = "") {
        //input format:19820321, output: 21 Mar 1982
        if (d !== '' && d !== null) {
            const inputStr = d.toString()

            const year = inputStr.substring(0, 4)
            const month = inputStr.substring(4, 6)
            const day = inputStr.substring(6, 8)

            const date = new Date(year+'-'+month+'-'+day)

            return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        }
    },
    getDateTimeDiff (dateFrom="", dateTo="") {
        // input Format: Fri Nov 19 2021 15:11:41 GMT+0800 (Malaysia Time)
    
        const d1 = new Date(dateFrom)
        const d2 = new Date(dateTo)

        // One day in milliseconds
        const oneDay = 1000 * 60 * 60 * 24
        const diffInTime = d2.getTime() - d1.getTime()
        const diffInDay = Math.floor(diffInTime / oneDay)
        const diffInHour = Math.floor(diffInTime / (1000 * 60 * 60)) // in hour
        const diffInMinute = Math.floor(diffInTime / (1000 * 60)) // in minute

        if (diffInDay >= 365) {
            const year = Math.floor(diffInDay / 365)
            return year + ' ' +( year === 1 ? 'year' : 'years') + ' ago'

        } else if (diffInDay >= 30) {
            const month = Math.floor(diffInDay / 30)
            return month + ' ' +( month === 1 ? 'month' : 'months') + ' ago'

        } else if (diffInDay >= 1) {
            return diffInDay + ' ' + ( diffInDay === 1 ? 'day' : 'days') + ' ago'

        } else if (diffInHour >= 1) {
            return diffInHour + ' ' + ( diffInHour === 1 ? 'hour' : 'hours') + ' ago'

        } else if(diffInMinute >= 1) {
            return diffInMinute + ' ' + ( diffInMinute === 1 ? 'minute' : 'minutes') + ' ago'

        } else {
            const diffInSecond = Math.floor(diffInTime / 1000)

            if (diffInSecond > 0) {
                return diffInSecond + ' ' + ( diffInSecond === 1 ? 'second' : 'seconds') + ' ago'
            } else {
                return 'Just now'
            }
        }
    },
    getDateTimeDiffInDay (dateFrom="", dateTo="") {
        // input Format: Fri Nov 19 2021 15:11:41 GMT+0800 (Malaysia Time)
    
        const d1 = new Date(dateFrom)
        const d2 = new Date(dateTo)

        // One day in milliseconds
        const oneDay = 1000 * 60 * 60 * 24
        const diffInTime = d2.getTime() - d1.getTime()
        const diffInDay = Math.round(diffInTime / oneDay)

        return diffInDay
    },
    getDateTimeDiffSimple (dateFrom="", dateTo="") {
        // input Format: Fri Nov 19 2021 15:11:41 GMT+0800 (Malaysia Time)
    
        const d1 = new Date(dateFrom)
        const d2 = new Date(dateTo)

        // One day in milliseconds
        const oneDay = 1000 * 60 * 60 * 24
        const diffInTime = d2.getTime() - d1.getTime()
        const diffInDay = Math.round(diffInTime / oneDay)
        const diffInHour = Math.round(diffInTime / (1000 * 60 * 60)) // in hour
        const diffInMinute = Math.round(diffInTime / (1000 * 60)) // in minute

        if (diffInDay >= 365) {
            const year = Math.ceil(diffInDay / 365)
            return year + ' ' +( year === 1 ? 'year' : 'years')

        } else if (diffInDay >= 30) {
            const month = Math.ceil(diffInDay / 30)
            return month + ' ' +( month === 1 ? 'month' : 'months')

        } else if (diffInDay >= 1) {
            return diffInDay + ' ' + ( diffInDay === 1 ? 'day' : 'days')

        } else if (diffInHour >= 1) {
            return diffInHour + ' ' + ( diffInHour === 1 ? 'hour' : 'hours')

        } else if(diffInMinute >= 1) {
            return diffInMinute + ' ' + ( diffInMinute === 1 ? 'minute' : 'minutes')

        } else {
            const diffInSecond = Math.round(diffInTime / 1000)
            if (diffInSecond > 0) {
                return diffInSecond + ' ' + ( diffInSecond === 1 ? 'second' : 'seconds')
            } else {
                return 'Just now'
            }
        }
    },
    convSize (size=0) {
        const mb = size / (1024 * 1024)
        const kb = size / 1024

        if (mb >= 0.1) {
            return mb.toFixed(1) + 'MB'
        } else if(kb > 0) {
            return kb.toFixed(1) + 'KB'
        } else {
            return size + 'B'
        }

    },
    convStringCapitalize (text="") {
        // Format: Save record
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    },
    convStringTitle (text="") {
        // Format: Save Record
        return text.replace(/\b\w/g, c => c.toUpperCase())
    },
    convSpaceEvery4Chars (text="") {
        return text.replace(/(.{4})(?=.)/g, '$1 ')
    }, 
    maskText(text="", format="") {
        if (format === 'half') {
            const len = text.length
            const temp = text.substring( 1, len-1)
            return text.substring(0, 1) + temp.replaceAll(/[0-9a-zA-Z,.@']/gi, '*') + text.charAt(len - 1)

        } else {
            return text.replaceAll(/[0-9a-zA-Z,.@']/gi, '*')
        }

    },
    encodeJsonToStr(text=[]) {
        // Sample input: [{}, {}]
        let newText = JSON.stringify(text)
        newText = btoa(encodeURIComponent(newText))

        return newText
    },
    decodeStrToJson(text="") {
        // Sample output: [{}, {}]
        let newText = text
        newText = decodeURIComponent(window.atob(text))
        newText = JSON.parse(newText)

        return newText
    },
    encodeJsonToStrSimple(text={}) {
        // Sample input: {}

        let tmpObj = []
        tmpObj.push(text)

        let newText = JSON.stringify(tmpObj)
        newText = btoa(encodeURIComponent(newText))

        return newText
    },
    decodeStrToJsonSimple(text="") {
        // Sample output: {}

        let newText = decodeURIComponent(window.atob(text))
        newText = JSON.parse(newText)

        return newText[0]
    },
    isEmptyObject(obj={}) {
        if (obj === null || obj === undefined || obj === '') {
            return true

        } else {

            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    return false
                }
            }
            return true
        }
    },
    getError(res = { "status": 0, "message": ""}) {

        // Sample: { "status": 1001, "message": "no_session", "description": "session id is undefined" }
        if (res.message !== null && res.message !== undefined) {
            if (res.message === 'user_not_found') {
                return i18n.global.t('message.func_err_user_not_found', { status: res.status })
    
            } else if (res.message === 'no_privilege') {
                return i18n.global.t('message.func_err_no_privilege', { status: res.status })
    
            } else if (res.message === 'invalid_open_id') {
                return i18n.global.t('message.func_errinvalid_open_id', { status: res.status })
    
            } else if (res.message === 'invalid_referral_id') {
                return i18n.global.t('message.func_err_invalid_referral_id')
                // SAMPLE: return i18n.global.t('message.func_err_', { status: res.status })
           
            } else if (res.message === 'action_not_match') {
                return i18n.global.t('message.func_err_action_not_match', { status: res.status })

            } else if (res.message === 'deleting_user') {
                return i18n.global.t('message.func_err_deleting_user')
            
            } else if (res.message === 'no_permission' && res.status === 30016) {
                // return 'Sorry, you do not have permission to perform the action.'
                return i18n.global.t('message.func_err_no_permission', { status: res.status })
            
            } else if (res.message === 'file_protected') {
                // return 'File is protected and cannot be uploaded.'
                return i18n.global.t('message.func_err_file_protected', { status: res.status })
                
            } else if (res.status === undefined ) {
                console.info('network errmsg desc', res.message)
                console.info('network err', res)
                // return 'Network error. Please try again later.'
                return i18n.global.t('message.func_err_undefined', { status: res.status })
    
            } else {
                console.info('code', res.status, typeof res.status, 'msg:', res.message)
                // return error.message + '. ' + res.data.status + ': ' + res.data.message
                // temporary show message to ease debug
                return i18n.global.t('message.func_err_oth', { email: 'wecare@signon.my',status: res.status, msg: res.message})
            }
        }

        return ''
    },
    clearPrevFolderLocalStorage() {

        Cookies.remove('leftSignDrawer')
        Cookies.remove('leftViewDrawer')
        Cookies.remove('project')
        Cookies.remove('signatoryCtrl')
        Cookies.remove('signatoryDoc')
        Cookies.remove('signatorySignee')

        Cookies.remove('signatoryDoc')
        Cookies.remove('signatorySignee')
        
        // ProjDoc
        localStorage.removeItem('leftSignDrawer')
        localStorage.removeItem('leftViewDrawer')
        localStorage.removeItem('project')
        localStorage.removeItem('signatoryCtrl')
        localStorage.removeItem('signatoryDoc')
        localStorage.removeItem('signatorySignee')

        localStorage.removeItem('signatoryDoc')
        localStorage.removeItem('signatorySignee')
    },
    clearPrevLocalStorage() {

        Cookies.remove('leftSignDrawer')
        Cookies.remove('leftViewDrawer')
        Cookies.remove('project')
        Cookies.remove('signatoryCtrl')
        Cookies.remove('signatoryDoc')
        Cookies.remove('signatorySignee')

        Cookies.remove('signatoryDoc')
        Cookies.remove('signatorySignee')

        // not clear userId to show in login username
        Cookies.remove('displayName')   
        Cookies.remove('avatar')
        Cookies.remove('userIsVerified')
        Cookies.remove('entityIsVerified')
        Cookies.remove('userStatus')
        Cookies.remove('userExpired')
        Cookies.remove('wlId')
        Cookies.remove('entityId')
        Cookies.remove('package')
        Cookies.remove('structure')
        Cookies.remove('openId')
        Cookies.remove('team')
        Cookies.remove('permission')
        Cookies.remove('entity')
        Cookies.remove('planInfo')
        Cookies.remove('geoInfo')
        Cookies.remove('googleToken')

        // ProjDoc
        localStorage.removeItem('leftSignDrawer')
        localStorage.removeItem('leftViewDrawer')
        localStorage.removeItem('project')
        localStorage.removeItem('signatoryCtrl')
        localStorage.removeItem('signatoryDoc')
        localStorage.removeItem('signatorySignee')

        localStorage.removeItem('signatoryDoc')
        localStorage.removeItem('signatorySignee')

        // not clear userId to show in login username
        localStorage.removeItem('displayName')   
        localStorage.removeItem('avatar')
        localStorage.removeItem('userIsVerified')
        localStorage.removeItem('entityIsVerified')
        localStorage.removeItem('userStatus')
        localStorage.removeItem('userExpired')
        localStorage.removeItem('wlId')
        localStorage.removeItem('entityId')
        localStorage.removeItem('package')
        localStorage.removeItem('structure')
        localStorage.removeItem('openId')
        localStorage.removeItem('team')
        localStorage.removeItem('permission')
        localStorage.removeItem('entity')
        localStorage.removeItem('planInfo')
        localStorage.removeItem('geoInfo')
        localStorage.removeItem('googleToken')

    },
    clearCookies() {
        Cookies.remove('leftSignDrawer')
        Cookies.remove('leftViewDrawer')
        Cookies.remove('project')
        Cookies.remove('signatoryCtrl')
        Cookies.remove('signatoryDoc')
        Cookies.remove('signatorySignee')

        Cookies.remove('signatoryDoc')
        Cookies.remove('signatorySignee')

        // not clear userId to show in login username
        
        Cookies.remove('avatar')
        Cookies.remove('currency')
        Cookies.remove('displayName')  
        Cookies.remove('entity')
        Cookies.remove('entityId')
        Cookies.remove('entityIsVerified')
        Cookies.remove('geoInfo')
        Cookies.remove('googleToken')
        Cookies.remove('lang')
        Cookies.remove('openId')
        Cookies.remove('package')
        Cookies.remove('permission')
        Cookies.remove('planInfo')
        Cookies.remove('scale')
        Cookies.remove('sessionId')
        Cookies.remove('signon')
        Cookies.remove('structure')
        Cookies.remove('team')
        Cookies.remove('theme')
        Cookies.remove('userExpired')
        Cookies.remove('userIsVerified')
        Cookies.remove('userLastLogin')
        Cookies.remove('userStatus')
        Cookies.remove('userId')
        Cookies.remove('version')
        Cookies.remove('wlId')
        
        
        
    },
    addLog(mod = "", func = "", err: unknown = "") {
        const p = {
            userId: localStorage.getItem('userId'),
            category: mod,
            title: func,
            description: err
        }

        axios.post('/report/log', p)
            .then((res) => {
                // console.info('addLog success', JSON.stringify(res))
            })
            .catch((error) => {
                if (error.code !== undefined) {
                    console.info('addLog | ERR', error, error.code + ' | ' +error.status + ' | ' + error.message + ' | ' + error.data +  ' | ' + error)
                }
            })
    },
    async getIP () {

        try {
            const apiKey = process.env.VUE_APP_API_KEY_IP_GEO
            const requestOptions: RequestInit = {
                method: "GET",
                redirect: "follow"
            }

            if (!apiKey) {
                throw new Error("VUE_APP_API_KEY_IP_GEO is not configured")
            }

            const response = await fetch("https://api.ipgeolocation.io/ipgeo?apiKey=" + apiKey, requestOptions)

            if (!response.ok) {
                throw new Error(
                    `IP Geolocation API returned HTTP ${response.status}`
                )
            }

            const geoInfo = await response.json()
            const ip = geoInfo.ip

            return ip

        } catch (error) {
            console.error("getIP() failed:", error)
            throw error
        }
         
    },
    loadScript(src: string = '', callback: (() => void) | null = null) {
        if (!src) return

        if (document.querySelector(`script[src="${src}"]`)) {
            callback?.()
            return
        }

        const script = document.createElement('script')
        script.src = src

        script.onload = () => callback?.()
        script.onerror = () => console.error(`Failed to load ${src}`)

        document.head.appendChild(script)
    }
}